import Category from "src/models/Category";

export default class CategoryFromSlug {
	constructor(rootCategories, slug) {
		this.slug = slug;
		this.rootCategories = rootCategories;
	}

	get category() {
		return this.rootCategories
			.map((rootCategory) => new Category(rootCategory))
			.find((rootCategory) => rootCategory.slug === this.slug);
	}
}
